import React from "react";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
import type { AdminRulesBaseRow } from "../../types";

const EMPTY_LABEL = "-";

export const EventTypeCell = <TRow extends AdminRulesBaseRow>(row: TRow) => (
  <span>{row.eventTypeName || EMPTY_LABEL}</span>
);

export const EventSubTypeCell = <TRow extends AdminRulesBaseRow>(row: TRow) => (
  <span>{row.eventSubTypeName || EMPTY_LABEL}</span>
);

export const TenantCell = <TRow extends AdminRulesBaseRow>(row: TRow) => (
  <span>{row.tenantName || row.tenantId || EMPTY_LABEL}</span>
);

interface ActiveToggleCellProps<TRow extends AdminRulesBaseRow> {
  row: TRow;
  onToggle: (row: TRow) => void;
  disabled?: boolean;
}

export const ActiveToggleCell = <TRow extends AdminRulesBaseRow>({
  row,
  onToggle,
  disabled,
}: ActiveToggleCellProps<TRow>) => (
  <InputSwitch
    inputId={`rule-active-switch-${row.id}`}
    checked={Boolean(row.active)}
    disabled={disabled}
    onChange={() => onToggle(row)}
  />
);

interface ActionsCellProps<TRow extends AdminRulesBaseRow> {
  row: TRow;
  onEdit: (row: TRow) => void;
  disabled?: boolean;
}

export const ActionsCell = <TRow extends AdminRulesBaseRow>({
  row,
  onEdit,
  disabled,
}: ActionsCellProps<TRow>) => (
  <Button
    icon="pi pi-pencil"
    severity="success"
    rounded
    aria-label="Editar"
    onClick={() => onEdit(row)}
    disabled={disabled}
  />
);
